
import Card from '../base/Card';

export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'María González',
      role: 'Contadora',
      image: 'https://readdy.ai/api/search-image?query=Professional%20latina%20woman%20in%20her%2030s%2C%20confident%20smile%2C%20business%20attire%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20warm%20lighting%2C%20trustworthy%20appearance%2C%20financial%20professional%20look&width=150&height=150&seq=maria-testimonial&orientation=squarish',
      content: 'Desde que uso Invirtiendo, logré ahorrar un 35% más cada mes. La clasificación automática de gastos me abrió los ojos sobre dónde se iba mi dinero.',
      savings: '$180.000',
      period: '6 meses'
    },
    {
      name: 'Carlos Mendoza',
      role: 'Ingeniero',
      image: 'https://readdy.ai/api/search-image?query=Professional%20latino%20man%20in%20his%2040s%2C%20confident%20expression%2C%20business%20casual%20shirt%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20natural%20lighting%2C%20trustworthy%20appearance%2C%20tech%20professional%20look&width=150&height=150&seq=carlos-testimonial&orientation=squarish',
      content: 'Las proyecciones con interés compuesto me motivaron a invertir. En un año, mi cartera creció un 28% siguiendo las recomendaciones de la plataforma.',
      savings: '$420.000',
      period: '1 año'
    },
    {
      name: 'Ana Rodríguez',
      role: 'Diseñadora',
      image: 'https://readdy.ai/api/search-image?query=Professional%20latina%20woman%20in%20her%2020s%2C%20creative%20professional%2C%20friendly%20smile%2C%20modern%20casual%20attire%2C%20clean%20white%20background%2C%20professional%20headshot%20style%2C%20bright%20lighting%2C%20approachable%20appearance&width=150&height=150&seq=ana-testimonial&orientation=squarish',
      content: 'Como freelancer, mis ingresos varían mucho. Invirtiendo me ayudó a planificar mejor y crear un fondo de emergencia que me da tranquilidad.',
      savings: '$95.000',
      period: '4 meses'
    }
  ];
  
  const formatCurrency = (amount: string) => {
    return amount;
  };
  
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Historias de Éxito Reales
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubre cómo otros usuarios han transformado su situación financiera 
            y logrado sus objetivos de ahorro e inversión con Invirtiendo.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="text-center hover:shadow-xl transition-shadow duration-300">
              <div className="mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-20 h-20 rounded-full mx-auto mb-4 object-cover object-top"
                />
                <h4 className="text-lg font-bold text-gray-900">{testimonial.name}</h4>
                <p className="text-emerald-600 font-medium">{testimonial.role}</p>
              </div>
              
              <blockquote className="text-gray-600 italic mb-6 leading-relaxed">
                "{testimonial.content}"
              </blockquote>
              
              <div className="bg-emerald-50 rounded-lg p-4 border border-emerald-200">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-emerald-700">Ahorro logrado:</span>
                  <span className="text-lg font-bold text-emerald-600">
                    {formatCurrency(testimonial.savings)}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium text-emerald-700">En:</span>
                  <span className="text-sm font-bold text-emerald-600">
                    {testimonial.period}
                  </span>
                </div>
              </div>
            </Card>
          ))}
        </div>
        
        {/* Estadísticas generales */}
        <div className="mt-16">
          <Card className="bg-gradient-to-r from-emerald-600 to-blue-600 text-white">
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-8">
                Resultados que Hablan por Sí Solos
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                <div>
                  <div className="text-4xl font-bold mb-2">15.000+</div>
                  <div className="text-emerald-100">Usuarios Activos</div>
                </div>
                <div>
                  <div className="text-4xl font-bold mb-2">$2.8M</div>
                  <div className="text-emerald-100">Ahorrado en Total</div>
                </div>
                <div>
                  <div className="text-4xl font-bold mb-2">89%</div>
                  <div className="text-emerald-100">Mejoraron sus Finanzas</div>
                </div>
                <div>
                  <div className="text-4xl font-bold mb-2">4.9/5</div>
                  <div className="text-emerald-100">Calificación Promedio</div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
}
